import * as React from 'react';
import ReactDom from 'react-dom';
import { emporiModule } from '@empori/util';
import { QuotesCarousel } from './components/quotesCarousel';
import { LogotypeCarousel } from './components/logotypeCarousel';
emporiModule('barkforsLoaded', {
    barkfors: {
        InitQuotesCarousel: function (element, quotes) {
            ReactDom.render(React.createElement(QuotesCarousel, { quotes: quotes }), document.querySelector(element));
        },
        InitLogotypeCarousel: function (element, logotypeUrls) {
            ReactDom.render(React.createElement(LogotypeCarousel, { logotypeUrls: logotypeUrls }), document.querySelector(element));
        }
    }
});
